import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AssessmentView from "./components/assessment-view/AssessmentView";
import ListView from "./components/assessment-list/AssessmentList";
import AssessmentEdit from "./components/assessment-edit/AssessmentEdit";
import MenuBar from "./components/menu-bar/MenuBar";
import { MeasuresProvider } from "./context/MeasuresContext";
import NotificationsView from "./components/notifications-view/NotificationsView";
import AuthProvider from "./components/auth-wrapper/AuthProvider";
import RollbarContext from "context/RollbarContext";
import Rollbar from "rollbar";
import { createMuiTheme, CssBaseline, MuiThemeProvider, StylesProvider } from "@material-ui/core";
import ProtocolListView from "components/protocol-list/ProtocolListView";
import ErrorBoundary from "components/error-page/ErrorBoundary";
import ProtectedRoute from "ProtectedRoute";
import AccessDeniedPage from "components/auth-wrapper/access-denied-page/AccessDeniedPage";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#000033",
    },
    secondary: {
      main: "#ffc709",
    },
  },
});

const menuItems = [
  { name: "All tests", to: "/" },
  { name: "Add new test", to: "/assessments/edit/" },
  { name: "Manage protocols", to: "/protocols/edit/" },
];

// TODO: Temp app state for tests
// TODO: Temp app state for protocols

export default function App() {
  const rollbar = new Rollbar({
    enabled: process.env.NODE_ENV === "production",
    accessToken: "d71dabc328a74a67900b09e653b83f34",
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: "production",
    },
  });

  return (
    <div className="App">
      <RollbarContext.Provider value={rollbar}>
        <CssBaseline />
        <StylesProvider injectFirst>
          <MuiThemeProvider theme={theme}>
            <Router>
              <AuthProvider>
                <MeasuresProvider>
                  <MenuBar menuItems={menuItems} />
                  <Routes>
                    <Route element={<ProtectedRoute />}>
                      <Route path={`/assessments/view/:assessmentId?`} element={<AssessmentView />} />
                      <Route
                        path={`/assessments/edit/:assessmentId?`}
                        element={
                          <ErrorBoundary>
                            <AssessmentEdit />
                          </ErrorBoundary>
                        }
                      />
                      <Route path={`/protocols/edit`} element={<ProtocolListView />} />
                      <Route path={"/"} element={<ListView />} />
                    </Route>
                    <Route
                      path="/access-denied"
                      element={
                        <AccessDeniedPage
                          appName="Adapt"
                          showLogout={false}
                          onLogout={() => {
                            return;
                          }}
                        />
                      }
                    />
                  </Routes>
                  <NotificationsView />
                  {/* <TermsAndConditionsView /> */}
                </MeasuresProvider>
              </AuthProvider>
            </Router>
          </MuiThemeProvider>
        </StylesProvider>
      </RollbarContext.Provider>
    </div>
  );
}
